import { render, staticRenderFns } from "./Affiliate.vue?vue&type=template&id=6de98b04&scoped=true&"
import script from "./Affiliate.vue?vue&type=script&lang=js&"
export * from "./Affiliate.vue?vue&type=script&lang=js&"
import style0 from "./Affiliate.vue?vue&type=style&index=0&id=6de98b04&scoped=true&lang=css&"
import style1 from "./Affiliate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de98b04",
  null
  
)

component.options.__file = "Affiliate.vue"
export default component.exports